import _ from 'lodash';
//import moment from 'moment';
import async from 'async';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//import IconButton from '@material-ui/core/Button';
//import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import AuthUserContainer from '../../containers/AuthUser';
import BulkDeliveryContainer from '../../containers/logistics/BulkDelivery';
import BulkDeliveryBatchContainer from '../../containers/logistics/BulkDeliveryBatch';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import FMPTextField from '../../components/ui/FMPTextField';
import ConfirmAndShowBulkDeliveryChanges from '../../components/Dialogs/ConfirmAndShowBulkDeliveryChanges';
import ConfirmCancelDeliveryDialog from '../../components/Dialogs/ConfirmCancelDeliveryDialog';
import ConfirmLockedDeliveryEditDialog from '../../components/Dialogs/ConfirmLockedDeliveryEditDialog';
import LockedDeliveryAlert from '../../components/LockedDeliveryAlert';
import * as deliveryLockLib from '../../libs/deliveryLock';
import { ProductSelect } from './helpers/selections';

const styles = (theme) => {
	return {
		sectionHeader : {
			margin : '30px 0px 10px 0px',
			textAlign : 'left',
			textTransform : 'uppercase',
			fontSize : 14,
			color : '#777',
			fontWeight : 900,
			letterSpacing : 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign : 'left',
			boxSizing: 'border-box',
			padding : 20,
			[theme.breakpoints.up('md')]: {
				padding : '10px 40px 40px 40px',
			}
		},
		formControl : {
			width : '100%',
			margin : '10px 0'
		},
		inputGroup : {
			borderLeft : '5px solid #ccc',
			marginTop : 2,
			marginBottom: 5,
		},
		submitButton : {
			fontSize : 18,
			borderRadius : '100px',
			padding : '20px 30px',
			textTransform: 'uppercase'
		},
		addInputButton : {
			borderRadius : '100px',
			marginTop : 20,
		},
		formFieldset : {
			border : 'none',
			margin : 0,
			padding : 0,
			minWidth : 0,
		},
		lockedForm : {
			pointerEvents : 'none',
			opacity : 0.6,
		},
		lastChange : {
			//border: '2px solid #bbb',
			//backgroundColor: '#f1f1f1',
			backgroundColor : '#D8F0FF',
			border: '1px solid #BADEFB',
			borderRadius: 4,
			padding : 20,
			fontSize : 16,
			lineHeight: 1.4,
			marginBottom : 10,
			marginTop : 20,
		},
	};
};

const formFields = {
	productType : 'etoh',
	pickupTerminalId : '',
	pickupSupplierId : '',
	deliveryTerminalId : '',
	deliveryBulkCustomerId: '',
	offloadNumber : '',
	carrierId : '',
	deliveryDate : '',
	loadingNumber : '',
	note : '',
	internalNote : '',
};

class UpdateBulkDelivery extends Component {
	constructor (props) {
		super(props);
		const bulkDeliveryId = _.get(
			this.props,
			['match', 'params', 'bulkDeliveryId']
		);

		this.state = {
			bulkDeliveryId: parseInt(bulkDeliveryId, 10),
			formFieldError: {},
			isConfirmDialogOpen : false,
			changeResult: undefined,
			updateParams : undefined,
			isCancelDialogOpen : false,
			isLockedEditDialogOpen : false,
			pendingLockSaveArgs : undefined,
		};
		this.state = _.merge(this.state, formFields);

		//- helpers
		//this.renderProductSelect = renderProductSelect.bind(this);
	}

	componentDidMount () {
		const {
			bulkDelivery, getBulkDelivery,
			carriers, searchCarriers,
			terminals, searchTerminals,
			suppliers, searchSuppliers,
			bulkCustomers, searchBulkCustomers,
		} = this.props;

		const {bulkDeliveryId} = this.state;

		if (!carriers.length) { searchCarriers(); }
		if (!terminals.length) { searchTerminals(); }
		if (!suppliers.length) { searchSuppliers(); }
		if (!bulkCustomers.length) { searchBulkCustomers(); }

		if (!bulkDelivery) {
			getBulkDelivery({
				params: {bulkDeliveryIds: [bulkDeliveryId]}
			});
		} else {
			const newState = this.getFormValuesFromBulkDelivery({bulkDelivery});
			this.setState(newState);
		}
	}


	// eslint-disable-next-line no-unused-vars
	componentDidUpdate(prevProps, nextState, snapshot) {
		const prevBulkDelivery = prevProps.bulkDelivery;
		const thisBulkDelivery = this.props.bulkDelivery;

		if (!prevBulkDelivery && thisBulkDelivery) {
			const newState = this.getFormValuesFromBulkDelivery({bulkDelivery : thisBulkDelivery});
			this.setState(newState);
		}
	}

	getFormValuesFromBulkDelivery = (props) => {
		const {bulkDelivery} = props;
		if (!bulkDelivery) { return; }

		const formValues = {};
		[
			'pickupTerminalId',
			'pickupSupplierId',
			'deliveryTerminalId',
			'deliveryBulkCustomerId',
			'carrierId',
			'offloadNumber',
			'loadingNumber',
			'note',
			'internalNote',
			'deliveryDate',
		].forEach(key => {
			if (_.isNil(bulkDelivery[key])) { return; }
			formValues[key] = bulkDelivery[key];
		});
		return formValues;
	};

	onChange (event, fieldName, index, attr) {
		const newState = {};
		if (!_.isNumber(index)) {
			newState[fieldName] = event.target.value;
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			newState[fieldName] = inputs;
		}

		if (fieldName === 'deliveryTerminalId') {
			newState.offloadNumber = this.getOffloadNumber({
				selectedTerminalId : newState[fieldName],
			});
		}

		this.setState(newState);
	}


	getOffloadNumber({ selectedTerminalId }) {
		const { deliveryBulkCustomerId, productType } = this.state;

		let offloadNumber = '';
		if (!deliveryBulkCustomerId || !productType ) {
			return offloadNumber;
		}

		const { bulkCustomers }	= this.props;
		const bulkCustomer = _.find(
			bulkCustomers,
			{ bulkCustomerId : deliveryBulkCustomerId}
		);
		if (!bulkCustomer) { return offloadNumber; }

		if (_.isEmpty(bulkCustomer.offloadTerminals)) {
			return offloadNumber;
		}

		bulkCustomer.offloadTerminals.forEach(offloadTerminal => {
			if (
				offloadTerminal.terminalId === selectedTerminalId
				&& offloadTerminal.productType === productType
			){
				offloadNumber = offloadTerminal.offloadNumber;
			}
		});
		return offloadNumber;
	}


	/*
	onDateTimeChange = (date, fieldName, index, attr) => {
		if (!_.isNumber(index)) {
			this.setState({[fieldName]: date});
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = date;
			} else {
				inputs[index] = date;
			}
			this.setState({[fieldName]: inputs});
		}
	};
	*/

	onDateTimeChange = (value, path) => {
		const arrayPath = (_.isString(path))
			? _.toPath(path)
			: path;

		const val = (_.isObject(value) && value.target)
			? value.target.value
			: value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};



	closeConfirmDialog = () => {
		this.setState({ isConfirmDialogOpen : false });
	};

	closeCancelDialog = () => {
		this.setState({ isCancelDialogOpen : false });
	};

	handleCancel = () => {
		this.setState({ isCancelDialogOpen : true });
	};

	//- Invoice lock: an issued/sent invoice freezes the delivery. Only the internal
	//- note stays editable without the canEditInvoicedDeliveries permission.
	isDeliveryLocked = () => deliveryLockLib.isDeliveryLocked(this.props.bulkDelivery);

	canEditInvoicedDeliveries = () => deliveryLockLib.canEditInvoicedDeliveries(this.props.authUser);

	//- Locked and no override permission: everything except the internal note is read-only
	isReadOnlyLocked = () => this.isDeliveryLocked() && !this.canEditInvoicedDeliveries();

	//- Fallback (invoice issued while the page was open): the server wants a
	//- reason — collect it and retry the same save. Returns true when it took over.
	handleLockRetryError = (err, saveArgs) => {
		if (deliveryLockLib.isLockReasonRequiredError(err) && this.canEditInvoicedDeliveries()) {
			this.setState({
				isConfirmDialogOpen : false,
				isLockedEditDialogOpen : true,
				pendingLockSaveArgs : saveArgs,
			});
			return true;
		}
		return false;
	};

	handleLockedEditConfirm = (reason) => {
		const saveArgs = this.state.pendingLockSaveArgs || {};
		this.setState({ isLockedEditDialogOpen : false, pendingLockSaveArgs : undefined });
		this.handleSave(_.assign({}, saveArgs, { lockOverrideReason : reason }));
	};

	handleSave = (p = {}) => {
		const { doNotSendAlert, lockOverrideReason } = p;


		const {
			getPotentialChanges,
			updateBulkDelivery,
			showErrors,
		} = this.props;

		//- Required fields
		const formFieldError = {};
		[
			{fieldName: 'productType', display: 'Product Type'},
			{fieldName: 'pickupTerminalId', display: 'Pickup Terminal'},
			{fieldName: 'pickupSupplierId', display: 'Pickup Supplier'},
			{fieldName: 'deliveryTerminalId', display: 'Delivery Terminal'},
			{fieldName: 'deliveryBulkCustomerId', display: 'Bulk Customer'},
			{fieldName: 'carrierId', display: 'Carrier'},
		].forEach(s => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		//- Get all the values and do individual checks
		const {
			productType,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			offloadNumber,
			carrierId,
			note,
			internalNote,
			bulkDeliveryId,
			loadingNumber,
			deliveryDate,
		} = this.state;

		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		//- Locked delivery: collect the required reason up front (the server
		//- still enforces it; internal-note-only saves ignore the reason)
		if (this.isDeliveryLocked() && this.canEditInvoicedDeliveries() && !lockOverrideReason) {
			this.setState({
				isLockedEditDialogOpen : true,
				pendingLockSaveArgs : { doNotSendAlert },
			});
			return;
		}

		//const deliveryDate = moment(this.state.deliveryDate).format('YYYY-MM-DD');

		//- Lock and load
		const params = {
			bulkDeliveryId,
			productType,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			offloadNumber,
			carrierId,
			deliveryDate,
			loadingNumber,
			note,
			internalNote,
			doNotSendAlert,
		};

		if (lockOverrideReason) {
			params.lockOverrideReason = lockOverrideReason;
		}

		async.waterfall([
			callback => {
				if (doNotSendAlert) {
					updateBulkDelivery({
						params,
						callback
					});
				} else {
					getPotentialChanges({
						params,
						callback
					});
				}
			},
			(r, callback) => {
				if (!doNotSendAlert) {
					const changeResult = r;
					const {changes} = changeResult;

					if (_.isEmpty(changes)) {
						return callback('Could not detect any changes??');
					}

					this.setState({
						isConfirmDialogOpen: true,
						updateParams: params,
						changeResult,
					});
				}
				return callback();
			}
		], e => {
			if (e) {
				if (this.handleLockRetryError(e, { doNotSendAlert })) { return; }
				showErrors([e]);
			}
		});
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render () {
		const {
			classes,
			bulkDelivery,
			carriers,
			terminals,
			suppliers,
			bulkCustomers,
			showErrors,
			updateBulkDelivery,
			cancelBulkDelivery,
		} = this.props;

		const {
			bulkDeliveryId,
			pickupTerminalId,
			pickupSupplierId,
			deliveryTerminalId,
			deliveryBulkCustomerId,
			carrierId,
			productType,
			isConfirmDialogOpen,
			isCancelDialogOpen,
			changeResult,
			updateParams,
		} = this.state;

		if (_.isEmpty(terminals) ||
			_.isEmpty(carriers) ||
			_.isEmpty(suppliers) ||
			_.isEmpty(bulkCustomers)
		) {
			return (<div>Fetching information...</div>);
		}

		if (!bulkDelivery) {
			return (<div>Bulk customer information...</div>);
		}

		const {
			isCancelled,
			cancellationReason,
		} = bulkDelivery;

		const isLocked = this.isDeliveryLocked();
		const canEditLocked = this.canEditInvoicedDeliveries();
		const isReadOnly = this.isReadOnlyLocked();

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								Update Bulk Delivery {bulkDeliveryId}
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>


						{isCancelled &&
						<div className={classes.lastChange}>
							<div className={classes.sectionHeader}>DELIVERY HAS BEEN CANCELLED</div>
							<strong><span role="img" aria-label="cancel">🚫</span> Cancellation Reason</strong><br/>
							{cancellationReason}
							<br/>
							<br/>
							<div>
								No further changes can be made to this order.
							</div>
							<br/>
						</div>
						}

						{isLocked &&
						<LockedDeliveryAlert canEditLocked={canEditLocked} />
						}

						<fieldset
							disabled={isReadOnly}
							className={`${classes.formFieldset}${isReadOnly ? ` ${classes.lockedForm}` : ''}`}
						>
							<div className={classes.sectionHeader}>Fuel Pickup</div>
							<ProductSelect
								label='Fuel Type'
								name='productType'
								productType={productType}
								onChange={this.onChange.bind(this)}
								disabled={isReadOnly}
							/>

							{this.renderTerminalSelectForPickup({
								label : 'Pickup Terminal',
								terminalId : pickupTerminalId,
								name : 'pickupTerminalId',
							})}

							{this.renderSupplierSelect({
								label : 'Ethanol Supplier',
								terminalId : pickupTerminalId,
								supplierId : pickupSupplierId,
								name : 'pickupSupplierId',
							})}

							<div className={classes.sectionHeader}>Fuel Offload</div>

							{this.renderBulkCustomerSelect({
								label : 'Bulk Customer',
								bulkCustomerId : deliveryBulkCustomerId,
								name : 'deliveryBulkCustomerId',
							})}

							{this.renderTerminalSelectForDelivery({
								label : 'Delivery Terminal',
								terminalId : deliveryTerminalId,
								name : 'deliveryTerminalId',
							})}

							<FMPTextField
								name={'offloadNumber'}
								label={"Offload Number"}
								controller={this}
								contained={true}
							/>
							<div className={classes.sectionHeader}>Carrier</div>

							{this.renderCarrierSelect({
								label : 'Carrier',
								carrierId : carrierId,
								name : 'carrierId',
							})}

							<div className={classes.sectionHeader}>Delivery Info</div>

							<Grid container spacing={3} className={classes.inputGroup}>
								<Grid item xs={12} md={4} style={{marginTop:-15, padding:'2px 10px'}}>
									<FMPDatePicker
										label="Delivery Date"
										path={'deliveryDate'}
										onChange={this.onDateTimeChange}
										value={this.getValue('deliveryDate')}
										error={this.getError('deliveryDate')}
									/>
								</Grid>

								<Grid item xs={12} md={4} style={{padding:'2px 10px'}}>
									<FMPTextField
										label={'Loading Number'}
										name={'loadingNumber'}
										controller={this}
										md={12}
									/>
								</Grid>
							</Grid>

							<div className={classes.sectionHeader}>Note</div>
							<FMPTextField
								name={'note'}
								label={"Note"}
								controller={this}
							/>

						</fieldset>

						<div className={classes.sectionHeader}>Internal Note</div>
						<FMPTextField
							name={'internalNote'}
							label={"Internal Note (only visible in FMP)"}
							controller={this}
						/>

						<div style={{textAlign: 'right'}}>
							{!isReadOnly &&
							<Button
								disabled={isCancelled}
								variant="contained"
								className={classes.addInputButton}
								onClick={this.handleCancel}
							>
								Cancel Delivery
							</Button>
							}

							<span style={{paddingLeft:10}} />

							<Button
								variant="contained"
								className={classes.addInputButton}
								onClick={() => { this.handleSave({doNotSendAlert : true}); }}
							>
								{isReadOnly ? 'Update Internal Note' : 'Update : No Change Request'}
							</Button>

							{!isReadOnly &&
							<span style={{paddingLeft:10}} />
							}

							{!isReadOnly &&
							<Button
								disabled={isCancelled}
								variant="contained"
								color="primary"
								className={classes.submitButton}
								onClick={this.handleSave}
							>
								Verify And Submit Changes
							</Button>
							}
						</div>

						<ConfirmAndShowBulkDeliveryChanges
							open={isConfirmDialogOpen}
							onClose={this.closeConfirmDialog}
							bulkDelivery={bulkDelivery}
							updateBulkDelivery={({ params, callback }) =>
								updateBulkDelivery({
									params,
									callback : (err, r) => {
										//- Invoice issued while the page was open: reopen via
										//- the reason dialog (the error still surfaces normally)
										if (err) {
											this.handleLockRetryError(err, { doNotSendAlert : false });
										}
										return callback(err, r);
									},
								})
							}
							changeResult={changeResult}
							updateParams={updateParams}
							showErrors={showErrors}
						/>

						<ConfirmLockedDeliveryEditDialog
							open={this.state.isLockedEditDialogOpen}
							onClose={() => this.setState({ isLockedEditDialogOpen : false })}
							onConfirm={this.handleLockedEditConfirm}
						/>

						<ConfirmCancelDeliveryDialog
							open={isCancelDialogOpen}
							onClose={this.closeCancelDialog}
							bulkDelivery={bulkDelivery}
							cancelDelivery={cancelBulkDelivery}
							showErrors={showErrors}
						/>

					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderTerminalSelectForPickup ({terminalId, name, label}) {
		const terminals = this.getTerminalsForProduct();

		const id = `ts_${name}`;
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={6}>
				<FormControl fullWidth={true} disabled={this.isReadOnlyLocked()}>
					<InputLabel htmlFor={id}>{label}</InputLabel>
					<Select
						value={terminalId}
						onChange={(e) => this.onChange(e, name) }
						input={<Input name={id} id={id}/>}
					>
						{terminals.map(item => {
							return (<MenuItem key={item.terminalId} value={item.terminalId}>
								{item.name}
							</MenuItem>);
						})}
					</Select>
				</FormControl>
			</Grid>
		</Grid>);
	}

	renderTerminalSelectForDelivery ({terminalId, name, label }) {
		const { terminals = [], warning } = this.getTerminalsForBulkCustomer();

		let disabled = this.isReadOnlyLocked();
		let helperText = '';
		if (warning) {
			disabled = true;
			helperText = warning;
		}

		const id = `ts_${name}`;
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={6}>
				<FormControl fullWidth={true} disabled={disabled}>
					<InputLabel htmlFor={id}>{label}</InputLabel>
					<Select
						value={terminalId}
						onChange={(e) => this.onChange(e, name) }
						input={<Input name={id} id={id}/>}
					>
						{terminals.map(item => {
							return (<MenuItem key={item.terminalId} value={item.terminalId}>
								{item.name}
							</MenuItem>);
						})}
					</Select>
					{!!helperText && <FormHelperText>{helperText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}


	renderSupplierSelect ({supplierId, terminalId, name, label}) {
		const suppliersForProduct = this.getSuppliersForTerminalProduct({ terminalId });

		let disabled = this.isReadOnlyLocked();
		let helperText = '';
		if (!terminalId) {
			disabled = true;
			helperText = 'Pick a terminal first';
		}

		const selectedBulkSupplier = this.getSelectedBulkSupplier();
		if (selectedBulkSupplier) {
			if (selectedBulkSupplier.requireLoadingNumbersFromSupplier) {
				helperText = 'Leave loading number blank and supplier will provide';
			} else if (selectedBulkSupplier.loadingNumber) {
				helperText = `Loading number : ${selectedBulkSupplier.loadingNumber}`;
			} else {
				helperText = '⚠️ Supplier missing loading numbers';
			}
		}

		const id = `ts_${name}`;
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={6}>
				<FormControl fullWidth={true} disabled={disabled}>
					<InputLabel htmlFor={id}>{label}</InputLabel>
					<Select
						value={supplierId}
						onChange={(e) => this.onChange(e, name) }
						input={<Input name={id} id={id}/>}
					>
						{suppliersForProduct.map(item => {
							return (<MenuItem key={item.supplierId} value={item.supplierId}>
								{item.name}
							</MenuItem>);
						})}
					</Select>
					<FormHelperText>{helperText}</FormHelperText>
				</FormControl>
			</Grid>
		</Grid>);
	}

	renderBulkCustomerSelect ({bulkCustomerId, name, label}) {
		const { bulkCustomers } = this.props;

		const id = `ts_${name}`;
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={6}>
				<FormControl fullWidth={true} disabled={this.isReadOnlyLocked()}>
					<InputLabel htmlFor={id}>{label}</InputLabel>
					<Select
						value={bulkCustomerId}
						onChange={(e) => this.onChange(e, name) }
						input={<Input name={id} id={id}/>}
					>
						{bulkCustomers.map(item => {
							return (<MenuItem key={item.bulkCustomerId} value={item.bulkCustomerId}>
								{item.name}
							</MenuItem>);
						})}
					</Select>
				</FormControl>
			</Grid>
		</Grid>);
	}

	renderCarrierSelect ({carrierId, name, label}) {
		const { carriers } = this.props;

		const id = `ts_${name}`;
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={6}>
				<FormControl fullWidth={true} disabled={this.isReadOnlyLocked()}>
					<InputLabel htmlFor={id}>{label}</InputLabel>
					<Select
						value={carrierId}
						onChange={(e) => this.onChange(e, name) }
						input={<Input name={id} id={id}/>}
					>
						{carriers.map(item => {
							return (<MenuItem key={item.carrierId} value={item.carrierId}>
								{item.name}
							</MenuItem>);
						})}
					</Select>
				</FormControl>
			</Grid>
		</Grid>);
	}

	getTerminalsForProduct() {
		const { productType } = this.state;
		const { terminals }	= this.props;

		const terminalsById = {};
		terminals.forEach(terminal => {
			if (_.isEmpty(terminal.bulkSuppliers)) {
				return;
			}

			terminal.bulkSuppliers.forEach(bulkSupplier => {
				if (bulkSupplier.product === productType){
					terminalsById[terminal.terminalId] = terminal;
				}
			});
		});
		return _.values(terminalsById);
	}

	getTerminalsForBulkCustomer() {
		const { deliveryBulkCustomerId, productType } = this.state;

		if (!deliveryBulkCustomerId || !productType ) {
			return {
				warning : 'Pick a bulk customer and a product type first'
			};
		}

		const { terminals, bulkCustomers }	= this.props;
		const terminalMap = _.keyBy(terminals, 'terminalId');
		const bulkCustomer = _.find(
			bulkCustomers,
			{ bulkCustomerId : deliveryBulkCustomerId}
		);

		if (!bulkCustomer) {
			return {
				warning : 'Could not find bulk customer',
			};
		}

		if (_.isEmpty(bulkCustomer.offloadTerminals)) {
			return {
				warning : 'Bulk customer does not have any valid offload terminals.'
			};
		}

		const retTerminals = [];
		bulkCustomer.offloadTerminals.forEach(offloadTerminal => {
			if (offloadTerminal.productType === productType){
				retTerminals.push(terminalMap[offloadTerminal.terminalId]);
			}
		});
		return {
			terminals : retTerminals,
		};
	}


	getSelectedBulkSupplier() {
		const { terminals} = this.props;
		const { pickupTerminalId, pickupSupplierId, productType } = this.state;
		if (!productType || !pickupTerminalId || !pickupSupplierId) { return null; }

		let selectedBulkSupplier = undefined;
		terminals.forEach(terminal => {
			if (_.isEmpty(terminal.bulkSuppliers)) { return; }
			if (pickupTerminalId !== terminal.terminalId) { return;}

			terminal.bulkSuppliers.forEach(bulkSupplier => {
				if (bulkSupplier.product !== productType) { return; }
				if (bulkSupplier.supplierId !== pickupSupplierId) { return; }
				selectedBulkSupplier = bulkSupplier;
			});
		});
		return selectedBulkSupplier;
	}

	getSuppliersForTerminalProduct({ terminalId }) {
		const { productType } = this.state;
		const { terminals, suppliers } = this.props;
		const suppliersById = {};

		const supplierMap = _.keyBy(suppliers, 'supplierId');

		terminals.forEach(terminal => {
			if (_.isEmpty(terminal.bulkSuppliers)) {
				return;
			}

			if (terminalId !== terminal.terminalId) {
				return;
			}


			terminal.bulkSuppliers.forEach(bulkSupplier => {
				if (bulkSupplier.product === productType){
					const id = bulkSupplier.supplierId;
					suppliersById[id] = supplierMap[id];
				}
			});
		});
		return _.values(suppliersById);
	}
}


function TabContainer({ children, dir }) {
	return (
		<Typography component="div" dir={dir} style={{ padding: 8 * 2 }}>
			{children}
		</Typography>
	);
}
TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
	dir: PropTypes.string.isRequired,
};

UpdateBulkDelivery.propTypes = {
	//- For update
	getBulkDelivery : PropTypes.func.isRequired,
	bulkDelivery : PropTypes.object,
	updateBulkDelivery : PropTypes.func.isRequired,
	getPotentialChanges : PropTypes.func.isRequired,
	cancelBulkDelivery : PropTypes.func,

	//- Add
	addBulkDeliveryBatch : PropTypes.func.isRequired,
	activateBulkDeliveryBatch : PropTypes.func.isRequired,
	getNextEmailForBulkDeliveryBatch : PropTypes.func.isRequired,

	searchCarriers : PropTypes.func.isRequired,
	carriers : PropTypes.array,

	searchTerminals : PropTypes.func.isRequired,
	terminals : PropTypes.array,

	searchSuppliers : PropTypes.func.isRequired,
	suppliers : PropTypes.array,

	searchBulkCustomers : PropTypes.func.isRequired,
	bulkCustomers : PropTypes.array,

	classes: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
	showErrors : PropTypes.func.isRequired,
	history : PropTypes.object.isRequired,
	authUser : PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	BulkDeliveryContainer,
	BulkDeliveryBatchContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
	BulkCustomersContainer,
	AuthUserContainer,
])(UpdateBulkDelivery);
